import { render, staticRenderFns } from "./payResultMobile.vue?vue&type=template&id=7100e6e8&scoped=true&"
import script from "./payResultMobile.vue?vue&type=script&lang=js&"
export * from "./payResultMobile.vue?vue&type=script&lang=js&"
import style0 from "./payResultMobile.vue?vue&type=style&index=0&id=7100e6e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7100e6e8",
  null
  
)

export default component.exports